import * as React from "react";

interface Description {
    code: string;
    label: string;
    description: string;
}

const parseText = (text: string | null): { header?: string, descriptions: Description[] } => {
    if (!text) {
        return { descriptions: [] };
    }

    const items = text.split('\n').filter(Boolean);
    let header;
    const descriptions: Description[] = [];

    items.forEach(item => {
        if (item.includes('=')) {
            const [code, rest] = item.split('=').map(part => part.trim());
            const [label, description] = rest.split(':').map(part => part.trim());
            descriptions.push({ code, label, description });
        } else if (!header) {
            header = item;
        }
    });

    return { header, descriptions };
};

export const formatTextToReactElement = (text: string | null): JSX.Element => {
    const { header, descriptions } = parseText(text);
    return (
        <div>
            {header && <p>{header}</p>}
            {descriptions.length > 0 && (
                <ul className={"list-style"}>
                    {descriptions.map((desc, index) => (
                        <li key={index}>
                            <strong>{desc.code} = {desc.label}:</strong> {desc.description}
                        </li>
                    ))}
                </ul>
            )}
        </div>
    );
};